module.exports = __webpack_public_path__ + "img/3.897f6ea9.jpg";